import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';

const CssSpinner = ({ size, theme, className }) => (
    <div className={
            classNames(
                className,
                'bs-cssSpinner',
                {
                    'bs-cssSpinner--small': size === 'small',
                    'bs-cssSpinner--medium': size === 'medium',
                    'bs-cssSpinner--large': size === 'large',
                    'bs-cssSpinner--light': theme === 'light',
                    'bs-cssSpinner--dark': theme === 'dark',
                    'bs-cssSpinner--bookie': theme === 'bookie',
                },
            )}
    >
        <div className="bs-cssSpinner__section bs-cssSpinner__section-1"></div>
        <div className="bs-cssSpinner__section bs-cssSpinner__section-2"></div>
        <div className="bs-cssSpinner__section bs-cssSpinner__section-3"></div>
    </div>
);

CssSpinner.defaultProps = {
    size: 'small',
    theme: 'bookie',
    className: '',
};

CssSpinner.propTypes = {
    size: PropTypes.string,
    theme: PropTypes.string,
    className: PropTypes.string,
};

export default CssSpinner;



// WEBPACK FOOTER //
// /src/js/common/cssSpinner/CssSpinner.jsx